<rt-icons-container></rt-icons-container>
<div class="config-container">
  <rt-heading *ngrxLet="currentAdmin$; let currentAdmin" class="item">{{
    currentAdmin.firstName
  }}</rt-heading>
  <div class="auth-token-input item" layout>
    <rt-input placeholder="auth token" [formControl]="authTokenControl" type="password"></rt-input>
    <rt-button variant="tertiary" margin-left-small-x (click)="onAuthTokenApply()">Apply</rt-button>
  </div>
  <rt-select
    [options]="(companies$ | ngrxPush)!"
    [value]="(currentCompany$ | ngrxPush)?.id!"
    (valueChange)="onCompanySelect($event)"
    class="company-picker item"
  ></rt-select>
</div>
<div class="playground-container">
  <aside></aside>
  <main rtScrollable>
    <rtc-detached-router-outlet></rtc-detached-router-outlet>
  </main>
</div>
